import { createLocalStorageField } from '@ipfabric/ui-components/utils/localStorageField';
import type { FC } from 'react';
import { useApiScopeRequirementMet } from 'utils/permissions/useApiScopeRequirementMet';
import { CloudLicensingGuide } from './CloudLicensingGuide';

const cloudLicensingGuideSeen = createLocalStorageField<'true'>(
  'cloudLicensingGuideSeen',
);

export type CloudLicensingGuideGateProps = {
  isCloudLicensingOverviewAccessible: boolean;
};

export const CloudLicensingGuideGate: FC<CloudLicensingGuideGateProps> = ({
  isCloudLicensingOverviewAccessible,
}) => {
  const apiScopeRequirementMet = useApiScopeRequirementMet();

  const seen = cloudLicensingGuideSeen.useValue() === 'true';

  const hasPermission = apiScopeRequirementMet({
    method: 'POST',
    path: '/tables/settings/administration/license-consumption/overview',
  });

  if (!isCloudLicensingOverviewAccessible || seen || !hasPermission) {
    return null;
  }

  return (
    <CloudLicensingGuide
      onClose={() => cloudLicensingGuideSeen.setValue('true')}
    />
  );
};
